<template>
  <el-pagination
    background
    @current-change="handleCurrentChange"
    :layout="pageLayout"
    :current-page="currentPage"
    :page-size="pageSize"
    :small="isPaginationSmall"
    v-bind:total="total">
  </el-pagination>

</template>

<script>
  export default {
    data() {
      return {
        currentPage: Number(this.$route.query.page),
        pageSize: 10,
        total: 0,
        fun: null,
        windowWidth: '',
        pageLayout: '',
        isPaginationSmall: false, // 是否是小型分页
      }
    },
    mounted() {
      const that = this;
      window.fullWidth = document.documentElement.clientWidth;
      that.windowWidth = window.fullWidth; // 宽
      if (window.fullWidth < 768) {
        that.pageLayout = 'total, prev, pager, next';
        this.isPaginationSmall = true;
      } else {
        that.pageLayout = 'total, prev, pager, next,jumper';
        this.isPaginationSmall = false;
      }

      window.onresize = () => {
        return (() => {
          window.fullWidth = document.documentElement.clientWidth;
          that.windowWidth = window.fullWidth; // 宽
          if (window.fullWidth < 768) {
            that.pageLayout = 'total, prev, pager, next';
            this.isPaginationSmall = true;
          } else {
            that.pageLayout = 'total, prev, pager, next,jumper';
            this.isPaginationSmall = false;
          }
        })()
      };
      if (this.$route.query.page != null) {
        this.currentPage = Number(this.$route.query.page);
      } else {
        this.currentPage = 1;
      }

    },
    watch: {
      windowWidth(val) {
        val < 768 ? this.pageLayout = 'total, prev, pager, next' :
          this.pageLayout = 'total, prev, pager, next,jumper'
      },
      '$route.query.page': {
        handler(newVal) {
          if (newVal === '1') {
            this.handleCurrentChange(1);
          }
        }
      }
    },
    methods: {
      handleCurrentChange(val) {
        var queryStr = JSON.stringify(this.$route.query);
        var query = JSON.parse(queryStr)
        query.page = val;
        this.$router.push({query: query})
        this.currentPage = val;
        this.fun();
      },

      initPagenator: function (fun, pageSize) {
        if (pageSize) {
          this.pageSize = pageSize;
        }
        this.fun = fun;

      },
      outputPagenator: function (total,pageSize) {
        if (pageSize) {
          this.pageSize = pageSize;
        }
        this.total = parseInt(total);
      }
    }
  }
</script>


